module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field"
  }, [(_vm.label) ? _c('label', {
    attrs: {
      "for": _vm.id
    },
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [(_vm.type === 'textarea') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempValue),
      expression: "tempValue"
    }],
    ref: "input",
    class: {
      'textarea': true, 'is-danger': _vm.fieldErrors
    },
    attrs: {
      "id": _vm.id,
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.tempValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.tempValue = $event.target.value
      }, _vm.handleInput],
      "keydown": _vm.handleKeyDown,
      "blur": _vm.handleBlur,
      "focus": _vm.handleFocus
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type !== 'textarea') ? _c('input', {
    ref: "input",
    class: {
      'input': true, 'is-danger': _vm.fieldErrors
    },
    attrs: {
      "id": _vm.id,
      "name": _vm.name,
      "type": _vm.type,
      "placeholder": _vm.placeholder,
      "required": _vm.required,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.tempValue
    },
    on: {
      "input": _vm.handleInput,
      "keydown": _vm.handleKeyDown,
      "blur": _vm.handleBlur,
      "focus": _vm.handleFocus
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.fieldErrors) ? _c('ul', {
    staticClass: "help is-danger form-errors"
  }, _vm._l((_vm.fieldErrors), function(error) {
    return _c('li', [_vm._v(_vm._s(error))])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7021a682"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/TextInput.vue
// module id = 162
// module chunks = 1